import React, { useState, useCallback } from "react";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import { useHistory, useLocation } from "react-router-dom";
import getSymbolFromCurrency from 'currency-symbol-map'
import { connect } from "react-redux";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { loginToApp } from "../../redux-services/actions/actions";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../components/CustomButtons/Button.js";
import themeStyle from "../../assets/jss/eclipse/components/themeStyle.js";
import { primaryColor, primaryIconColor } from "../../style.scss";
import { ReactComponent as ConfirmTransactionIcon } from '../../assets/img/journey_transfer.svg'
import { v4 as uuidv4 } from 'uuid';
import { MWalletTransfersApi, DCustomerManagementApi, QPaymentsApi } from "eclipse-react-sdk/services";
import { SpinnerComponent } from "react-element-spinner";
import AlertNotification from "../../components/Snackbar/AlertNotification.js";
import { PaymentType } from "../../eclipse-react-sdk/services/models";
import { AuthQueryParamWithTemplateId } from "../../default-route.js";
import { ToBinary } from "../../utils.js";

const useStyles = makeStyles(themeStyle);

export function ConfirmPayAmount(props) {
  const manifestSettings = props?.appData?.template?.manifestSettings
  const walletTitleText = props?.appData?.template?.pwaAppOptions?.walletTitleText;
  const walletDetailData = useLocation().state?.walletDetailData;
  const scannedQRData = useLocation().state?.scannedQRData;
  const paymentDetails = useLocation().state?.paymentDetails;
  const cardDetailData = useLocation().state?.cardDetailData;
  const paymentProcess = useLocation().state?.paymentProcess;
  const fromScreen = useLocation().state?.fromScreen;

  const history = useHistory();
  const classes = useStyles();

  const [isLoading, setLoading] = useState(false);
  const [alertData, setAlert] = useState(null);

  const showAlert = (alertDisplay, alertType, message) => {
    setAlert({ isAlertDisplay: alertDisplay, alertType: alertType, alertMessage: message })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }

  const goToSuccessPayAmount = (successPayData) => {
    history.push({
      pathname: '/pages/success-pay-amount',
      state: { walletDetailData: walletDetailData, scannedQRData: scannedQRData, successPayData: successPayData }
    });
  };

  const backToQRPay = () => {
    history.push({
      pathname: '/pages/pay-amount',
      state: { scannedQRData: scannedQRData, fromScreen: fromScreen }
    });
  };

  const backToDashboard = useCallback(() => {
    const appData = {
      ...props?.appData,
      isRefresh: true
    }
    props.confirmPayAmountHandler(appData);
    history.push({
      pathname: '/pages/dashboard',
    });
  }, [history, props])

  const redirectToErrorScreen = (fromScreen, toScreen) => {
    history.push({
      pathname: toScreen,
      state: { fromScreen: fromScreen }
    });
  }

  const doQRWalletTransfer = () => {
    setLoading(true);
    const qrWalletTransferAPI = new MWalletTransfersApi();
    const createQRTransferWalletBody = {
      amount: +paymentDetails.amount + (paymentDetails?.tipAmount ? +paymentDetails?.tipAmount : 0),
      description: scannedQRData?.description ? scannedQRData?.description : `QR Payment to ${scannedQRData?.code}`,
      externalUniqueId: uuidv4(),
      fromWalletId: paymentDetails?.fromWalletCard,
      toWalletId: paymentDetails?.toWallet
    }
    qrWalletTransferAPI.tenantsTenantIdWalletsTransfersPost(props?.appData?.auth?.tenantId, createQRTransferWalletBody).then((qrWalletTransferAPIResponse) => {
      setLoading(false);
      goToSuccessPayAmount(paymentDetails);
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/pages/pay-qr', '/pages/error');
      }
    });
  }

  const updateQRPaymentAmount = (paymentData) => {
    const cardPaymentsAPI = new QPaymentsApi();
    const cardPaymentRequestBody = {
      additionalFields: paymentData?.additionalFields,
      cardOnFileId: paymentDetails?.fromWalletCard,
      amount: +paymentDetails?.amount + (paymentDetails?.tipAmount ? +paymentDetails?.tipAmount : 0),
      landingUrl: `${window.location.origin}${process.env.PUBLIC_URL}/pages/success-card-payment${AuthQueryParamWithTemplateId() ? AuthQueryParamWithTemplateId() : ''}`
    }

    cardPaymentsAPI.tenantsTenantIdPaymentsPaymentIdPut(props?.appData?.auth?.tenantId, paymentData?.paymentId, cardPaymentRequestBody).then((cardPaymentsAPIResponse) => {
      if (cardPaymentsAPIResponse?.data && cardPaymentsAPIResponse?.data?.paymentId) {
        const qrPaymentData = {
          paymentDetails:paymentDetails,
          paymentId: cardPaymentsAPIResponse.data?.paymentId,
          status: cardPaymentsAPIResponse.data?.status,
          scannedQRData,
          paymentProcess,
          cardDetailData,
        }
        if (cardPaymentsAPIResponse.data?.completionUrl) {
          window.localStorage.setItem('appstate', btoa(ToBinary(JSON.stringify({ ...props?.appData, qrPaymentData }))));
          window.location.replace(cardPaymentsAPIResponse.data?.completionUrl);
        } else {
          const appData = {
            ...props?.appData,
            isRefresh: true,
            qrPaymentData,
            walletDetailData,
            scannedQRData
          }
          props.confirmPayAmountHandler(appData);
          history.push({
            pathname: '/pages/success-card-payment'
          });
        }
      } else {
        setLoading(false);
        showAlert(true, 'ERROR', `Something went wrong. Please try again!`);
      }
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/pages/dashboard', '/pages/error');
      }
    });
  }

  const doQRPaymentWithCard = () => {
    setLoading(true);
    const cardPaymentsAPI = new DCustomerManagementApi();

    const additionalFields = [];
    scannedQRData.additionalFields.forEach(control => {
      if (paymentDetails[control?.id]) {
        control = { ...control, value: paymentDetails[control?.id] };
      }
      additionalFields.push(control);
    });

    const cardPaymentRequestBody = {
      additionalFields: additionalFields,
      externalUniqueId: uuidv4(),
      description: scannedQRData?.description ? scannedQRData?.description : `QR Payment to ${scannedQRData?.code}`,
      type: PaymentType.ZAQRCODE,
      currency: 'ZAR',
      paymentData: scannedQRData?.code
    }

    cardPaymentsAPI.tenantsTenantIdCustomersCustomerIdPaymentsPost(props?.appData?.auth?.tenantId, props?.appData?.customer?.customerId, cardPaymentRequestBody).then((cardPaymentsAPIResponse) => {
      if (cardPaymentsAPIResponse.data && cardPaymentsAPIResponse.data?.paymentId && cardPaymentsAPIResponse.data?.paymentId > 0) {
        updateQRPaymentAmount(cardPaymentsAPIResponse.data);
      } else {
        setLoading(false);
        showAlert(true, 'ERROR', `Something went wrong. Please try again!`);
      }
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/pages/dashboard', '/pages/error');
      }
    });
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    if (paymentProcess === 'WALLETS') {
      doQRWalletTransfer();
    } else {
      doQRPaymentWithCard();
    }
  }

  return (
    <div>
      <SpinnerComponent loading={isLoading} position="global" color={primaryColor} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ display: 'flex' }}>
              <ArrowBackIosIcon className={classes.linkColor} onClick={backToQRPay}></ArrowBackIosIcon>
              <span className={classes.title}>Pay a QR code</span>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center', marginTop: '20px' }}>
              <ConfirmTransactionIcon fill={primaryIconColor} stroke={primaryIconColor} />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-b-0'}><b>Please confirm that you want to pay</b></p>
              <h2 style={{ color: primaryIconColor, margin: '0' }} className={classes.textCenter}><b>{getSymbolFromCurrency(walletDetailData?.currency)}{(+paymentDetails.amount + (paymentDetails?.tipAmount ? +paymentDetails?.tipAmount : 0)).toFixed(2)}</b></h2>
              {paymentProcess === 'WALLETS' ?
                <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-b-0 m-t-0'}><b>to ({scannedQRData.reference}) from your ({manifestSettings?.brand.toUpperCase()} {walletTitleText?.toLowerCase()}-{paymentDetails.fromWalletCard}).</b></p>
                : <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-b-0 m-t-0'}><b>to ({scannedQRData.reference}) from your (card-{cardDetailData?.alias + ' - **' + cardDetailData?.last4Digits}).</b></p>}
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={6} sm={6} md={6} style={{ marginTop: '40px' }}>
              <Button className={classes.buttonRadius} size="lg" block color="transparent" onClick={backToDashboard} >Cancel</Button>
            </GridItem>
            <GridItem xs={6} sm={6} md={6} style={{ marginTop: '40px' }}>
              <Button className={classes.buttonRadius} size="lg" block color="primary" type="button" onClick={handleSubmit}>Continue</Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {alertData?.isAlertDisplay ? <AlertNotification alertData={alertData} /> : null}
    </div>
  )
}


const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

const mapDispatchToProps = dispatch => ({
  confirmPayAmountHandler: data => dispatch(loginToApp(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPayAmount)